import { createSlice } from "@reduxjs/toolkit";

// Define initial state for the slice.

const initialState = {
  data: [],
  loading: false,
  error: null,
  distribution: {},
  receipts: { error: null, loading: false, data: [] },
  providerAccounts: { error: null, loading: false, data: [] },
  storeQuantityError: [],
  NonIps: { error: null, loading: false, data: [] },
  drafts: { error: null, loading: false, data: [] },
  draftLoading: false,
};

//  Define slice and it's reducer functions.
const providerOutSlice = createSlice({
  name: "providerOut",
  initialState,
  reducers: {
    setData(state, action) {
      state.data = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setProviderOut(state, action) {
      state.distribution = action.payload;
    },
    setProviderOutReceipts(state, action) {
      state.receipts = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      };
    },
    setNoneIps(state, action) {
      state.NonIps = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      };
    },
    setProviderAccount(state, action) {
      state.providerAccounts = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      };
    },
    setStoreQuantityError(state, action) {
      state.storeQuantityError = action.payload;
    },
    resetState(state) {
      state.data = [];
      state.loading = false;
      state.error = null;
      state.distribution = {};
      state.receipts = { error: null, loading: false, data: [] };
      state.storeQuantityError = [];
    },
    resetStoreQuantityError(state) {
      state.storeQuantityError = [];
    },
    resetReceiptOut(state) {
      state.receipts = { error: null, loading: false, data: [] };
    },
    resetProviderAccount(state) {
      state.providerAccounts = { error: null, loading: false, data: [] };
    },
    resetNoneIps(state) {
      state.NonIps = { error: null, loading: false, data: [] };
    },
    setDrafts(state, action) {
      state.drafts = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      };
    },
    setDraftLoading(state, action) {
      state.draftLoading = action.payload;
    },
    resetDrafts(state) {
      state.drafts = { error: null, loading: false, data: [] };
    },
    addDraft(state, action) {
      state.drafts.data.push(action.payload);
    },
    removeDraft(state, action) {
      state.drafts.data = state.drafts.data.filter(draft => draft.id !== action.payload);
    },
    updateDraft(state, action) {
      const index = state.drafts.data.findIndex(draft => draft.id === action.payload.id);
      if (index !== -1) {
        state.drafts.data[index] = action.payload;
      }
    },
  },
});

export const providerOutAction = providerOutSlice.actions;

export default providerOutSlice;
